import React from "react";
import { Box, Link, Typography } from "@mui/material";
import hourglassIcon from "@assets/facilityNetwork/conflict-hourglass.svg";
import reviewChevron from "@assets/facilityNetwork/conflict-review-chevron-warn.svg";
import FacilityNetworkFigmaIcon from "./FacilityNetworkFigmaIcon";
import type { ConditionalPendingRequestData } from "./conditionalPendingUtils";
import { FN } from "./facilityNetworkTheme";

type Props = {
  request: ConditionalPendingRequestData;
  onAction: () => void;
};

/** Figma 9227:111011 — C waiting: amber hourglass banner */
export default function FacilityNetworkConditionalPendingBanner({
  request,
  onAction,
}: Props) {
  const child = request.childFacilityName;
  const subtitle = `${child} already has a parent (${request.currentParentFacilityName}). Both ${child} and their current parent must approve before this link establishes.`;

  return (
    <Box
      sx={{
        bgcolor: "#fff4e5",
        border: "1px solid #fabc89",
        borderRadius: "4px",
        p: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        flexWrap: { xs: "wrap", md: "nowrap" },
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: 0 }}>
        <Box sx={{ width: 20, height: 20, flexShrink: 0, display: "flex", alignItems: "center" }}>
          <FacilityNetworkFigmaIcon src={hourglassIcon} size={20} />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: FN.fontFamily,
              fontSize: 14,
              fontWeight: 600,
              color: "#8b4409",
              lineHeight: "20px",
            }}
          >
            {`Link request to ${request.childFacilityName} is conditionally pending`}
          </Typography>
          <Typography
            sx={{
              fontFamily: FN.fontFamily,
              fontSize: 14,
              fontWeight: 400,
              color: FN.figmaAccent,
              lineHeight: "20px",
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>

      <Link
        component="button"
        type="button"
        underline="none"
        onClick={() => onAction()}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          flexShrink: 0,
          px: 1.5,
          py: 0.75,
          fontFamily: FN.fontFamily,
          fontSize: 14,
          fontWeight: 400,
          color: "#8b4409",
          lineHeight: "20px",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        Review Request
        <FacilityNetworkFigmaIcon src={reviewChevron} size={12} />
      </Link>
    </Box>
  );
}
